import classNames from 'classnames';
import { TextButton } from 'legacy/components/Button';

import { PROPERTY_DATA_SOURCES } from 'legacyGraphQL/constants';

import { PROPERTY_DETAILS_FIELD_COMPONENTS } from 'legacy/utils/property-details';

import AttributeAdjustmentBadge from 'legacy/components/AttributeAdjustmentBadge';
import PropertyAttributeValueContainer from 'legacy/containers/property-attribute-value';

import { PropertyDetailsGeneral as theme } from 'legacy/css-modules';

const PropertyDetailsGeneral = ({
  addressId,
  attributeGroups,
  property,
  recomputing,
  adjustments,
  editable,
  editing,
  onAdjust,
  onSubmit,
  onCancel,
  isEffectiveDateReport
}) => {
  return (
    <div>
      <div className={theme.ActionBar}>
        {editable && !isEffectiveDateReport ? (
          editing ? (
            <span>
              <TextButton
                dataHcName="property-details-cancel-button"
                className={classNames(theme.TextButton, theme.TextButtonCancel)}
                onClick={onCancel}
                primary={false}
              >
                Cancel
              </TextButton>
              <TextButton
                dataHcName="property-details-save-button"
                onClick={onSubmit}
                className={theme.TextButton}
              >
                Save
              </TextButton>
            </span>
          ) : (
            <span>
              <TextButton
                dataHcName="property-details-adjust-button"
                disabled={recomputing}
                className={theme.TextButton}
                onClick={onAdjust}
              >
                Adjust fields
              </TextButton>
            </span>
          )
        ) : null}
      </div>
      <div className={theme.AttributeGroupContainer}>
        {attributeGroups.map((group, g) => {
          return (
            <div
              key={`property-detail-group-${g}`}
              className={theme.AttributeGroup}
              style={{ flex: `1 1 ${100 / attributeGroups.length}%` }}
            >
              {group.map((attribute, a) => {
                if (!attribute) {
                  return null;
                }
                const EditComponent =
                  PROPERTY_DETAILS_FIELD_COMPONENTS[attribute.fieldType];
                return (
                  <div
                    key={`property-detail-attribute-${g}-${a}`}
                    className={theme.Attribute}
                  >
                    <div
                      data-hc-name="property-details-general-label"
                      className={theme.AttributeLabel}
                    >
                      {attribute.label}
                    </div>
                    <div className={theme.AttributeValue}>
                      {editing && EditComponent ? (
                        <EditComponent
                          name={attribute.key}
                          value={property[attribute.key]}
                          {...attribute.fieldProps}
                        />
                      ) : (
                        <PropertyAttributeValueContainer
                          addressId={addressId}
                          attrKey={attribute.key}
                          source={PROPERTY_DATA_SOURCES.ANY}
                          property={property}
                        />
                      )}
                      <div className={theme.AdjustmentBadge}>
                        {adjustments.hasOwnProperty(attribute.key) ? (
                          <AttributeAdjustmentBadge
                            {...adjustments[attribute.key]}
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PropertyDetailsGeneral;
